module.exports = __webpack_public_path__ + "static/media/party-hat.967bd40c.png";